
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { MaterialType } from "@/types/materialType";
import { useState } from "react";

interface NewMaterialTypeDialogProps {
  open: boolean;
  onClose: () => void;
  onSave: (material: Omit<MaterialType, 'id' | 'created_at'>) => void;
}

export function NewMaterialTypeDialog({
  open,
  onClose,
  onSave,
}: NewMaterialTypeDialogProps) {
  const [newMaterial, setNewMaterial] = useState<Omit<MaterialType, 'id' | 'created_at'>>({
    prefix: '',
    material_type: '',
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSave(newMaterial);
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Novo Tipo de Material</DialogTitle>
        </DialogHeader>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="prefix">Prefixo</Label>
            <Input
              id="prefix"
              value={newMaterial.prefix}
              onChange={(e) =>
                setNewMaterial({
                  ...newMaterial,
                  prefix: e.target.value.toUpperCase(),
                })
              }
              maxLength={3}
              required
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="material_type">Tipo de Material</Label>
            <Input
              id="material_type"
              value={newMaterial.material_type}
              onChange={(e) =>
                setNewMaterial({
                  ...newMaterial,
                  material_type: e.target.value,
                })
              }
              required
            />
          </div>

          <div className="flex justify-end space-x-2">
            <Button variant="outline" onClick={onClose} type="button">
              Cancelar
            </Button>
            <Button type="submit">Salvar</Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
}
